import { render } from "./EzaButton.vue?vue&type=template&id=d9e8ef6a&scoped=true"
import script from "./EzaButton.vue?vue&type=script&lang=js"
export * from "./EzaButton.vue?vue&type=script&lang=js"

import "./EzaButton.vue?vue&type=style&index=0&id=d9e8ef6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d9e8ef6a"

export default script